import React, {useState,useEffect} from "react";
import styles from "./inputText.module.scss";

export function DefaultInputText({
  label = "",
  type = "text",
  placeholder = "",
  value,
  onChange = () => {},
  name,
  disabled = false,
  multiline = false,
  rows = 4,
  useUnit = false,
  unit = "",
  autoClearPlaceholder = false,
  onBlur,
}) {
  const [localPlaceholder, setLocalPlaceholder] = useState(placeholder);

  const handleChange = (e) => {
    onChange?.(e.target.value);
  };

  const allowedTypes = ["text", "number", "email", "password"];
  const inputType = allowedTypes.includes(type) ? type : "text";
  const generateInputName = (label) =>
    label
      ? label.replace(/[^\w가-힣]/g, "_")
      : "input";

  const inputName = name || generateInputName(label);

  const handleFocus = () => {
    if (autoClearPlaceholder) {
      setLocalPlaceholder("");
    }
  };

  const handleBlur = () => {
    if (autoClearPlaceholder) {
      setLocalPlaceholder(placeholder);
    }
  };

  return (
    <div className={`${styles.defaultInput} ${useUnit ? styles.useUnit : ""}`}>
      {label && <label className={styles.label} htmlFor={inputName}>{label}</label>}
      {multiline ? (
        <textarea
          className={styles.input}
          id={inputName}
          name={inputName}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          rows={rows}
        />
      ) : (
        <input
          className={styles.input}
          type={inputType}
          id={inputName}
          name={inputName}
          placeholder={localPlaceholder}
          value={value}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur= {(e) =>{
            handleBlur(e);
            onBlur?.(e);
          }}
          disabled={disabled}
        />
        
      )}
      {useUnit && <span className={styles.spanUnit}> {unit} </span>}
    </div>
  );
}

export function MinMaxInput  ({
  type = "min",            // "min" 또는 "max"
  counterpartValue = null, // 반대값 (최대일 경우 min값, 최소일 경우 max값)
  value,                   // 현재 값
  onChange,                // 검증된 값만 상위 전달
  unit = "만원",           // 단위
})  {
  const [inputValue, setInputValue] = useState(value ?? "");

  useEffect(() => {
    setInputValue(value ?? "");
  }, [value]);

  const handleChange = (val) => {
    const numericOnly = val.replace(/[^0-9]/g, "");
    setInputValue(numericOnly);
  };
  
  const handleBlur = () => {
    console.log(inputValue);
    if (inputValue === "") {
      onChange("");
      return;
    }
  
    const parsed = Number(inputValue);
    const hasCounterpart = counterpartValue !== null && counterpartValue !== undefined && counterpartValue !== "";
  
    if (!isNaN(parsed)) {
      const counterpartNum = Number(counterpartValue);
      console.log("counter" + counterpartNum);
      const isValid =
        type === "min"
          ? !hasCounterpart || parsed <= counterpartNum
          : !hasCounterpart || parsed >= counterpartNum;
  
      if (isValid) {
        onChange(parsed);
      }
    }
  };

  return (
    <DefaultInputText
      type="text"
      placeholder={type === "min" ? "최소" : "최대"}
      value={inputValue}
      onChange={handleChange}
      onBlur={handleBlur}
      useUnit={true}
      unit={unit}
      autoClearPlaceholder={true}
    />
  );
};

